export const textStyles = isOutgoing => ({
  p: 2,
  width: 'auto',
  maxWidth: '791px',
  borderRadius: isOutgoing ? '3px 10px 10px 10px' : '10px 3px 10px 10px',
  display: 'inline',
  ml: isOutgoing ? 0 : 'auto',
  mr: isOutgoing ? 'auto' : 0,
});

export const hyperlinkStyles = () => ({
  textTransform: 'none',
  fontWeight: 600,
  mt: '-3px',
  letterSpacing: '0.15px',
  fontSize: 'inherit',
  py: 0,
  px: '2px',
});
